import { Dispatch } from "redux";
import { CreateAppCustomerStipDocumentAssociation } from "../../Components/Dialogs/CreateAppCustomerStipDocumentAssociation";
import { IndirectDecisionReason, ApplicationStipulation, DecisionCodeDecisionReasonDefault } from "../../Components/IndirectStipsEditor/IndirectStipulation";
import { CreateIndirectDecisionDenialReasons } from "../../Data/CreateIndirectDecisionDenialReason";
import { IStipulationCategory } from "../../Interfaces/StipulationTypes";
import { DealerServiceState } from "./reducer";

export const SET_DEALER_SERVICE_COMMENTS = 'SET_DEALER_SERVICE_COMMENTS';
export interface SetDealerServiceCommentAction {
  type: typeof SET_DEALER_SERVICE_COMMENTS;
  payload: { decisionComments: string }
};
export const setDealerServiceComments = (decisionComments: string): SetDealerServiceCommentAction => {
  return {
    type: SET_DEALER_SERVICE_COMMENTS,
    payload: { decisionComments }
  }
};
export const SET_DEALER_DECISION_CODE = 'SET_DEALER_DECISION_CODE';
export interface SetDealerServiceDecisionCodeAction {
  type: typeof SET_DEALER_DECISION_CODE;
  payload: { decisionCode: string }
};
export const setDealerServiceDecisionCode = (decisionCode: string): SetDealerServiceDecisionCodeAction => {
  return {
    type: SET_DEALER_DECISION_CODE,
    payload: { decisionCode }
  }
};

export const SET_DEALER_SERVICE_STATE = 'SET_DEALER_SERVICE_STATE';
export interface SetDealerServiceStateAction {
  type: typeof SET_DEALER_SERVICE_STATE;
  payload: { state: DealerServiceState }
};
export const setDealerServiceState = (state: DealerServiceState): SetDealerServiceStateAction => {
  return {
    type: SET_DEALER_SERVICE_STATE,
    payload: { state }
  }
};

export const CLEAR_DEALER_SERVICE_STATE = 'CLEAR_DEALER_SERVICE_STATE';
export interface ClearDealerServiceStateAction {
  type: typeof CLEAR_DEALER_SERVICE_STATE;
};
export const clearDealerServiceState = (): ClearDealerServiceStateAction => {
  return {
    type: CLEAR_DEALER_SERVICE_STATE,
  }
};

export const LOAD_INDIRECT_STIPS_AND_DECISION_REASONS = 'LOAD_INDIRECT_STIPS_AND_DECISION_REASONS';
export const LOAD_INDIRECT_STIPS_AND_DECISION_REASONS_SUCCESS = 'LOAD_INDIRECT_STIPS_AND_DECISION_REASONS_SUCCESS';
export interface LoadIndirectStipsAndDecisionReasonsAction {
  type: typeof LOAD_INDIRECT_STIPS_AND_DECISION_REASONS;
  payload: { applicationId: string };
}
export const loadIndirectStipsAndDecisionReasons = (applicationId: string): LoadIndirectStipsAndDecisionReasonsAction => {
  return {
    type: LOAD_INDIRECT_STIPS_AND_DECISION_REASONS,
    payload: { applicationId }
  };
}
export interface LoadApplicationStipsAndDecisionReasonsSuccessAction {
  type: typeof LOAD_INDIRECT_STIPS_AND_DECISION_REASONS_SUCCESS;
  payload: { 
    applicationStipulations: ApplicationStipulation[], 
    adverseActionReasons: IndirectDecisionReason[] ,
    decisionCodeDecisionReasonDefaults: DecisionCodeDecisionReasonDefault[]
  }; // Replace with actual type
}
export const loadIndirectStipsAndDecisionReasonsSuccess = (
  applicationStipulations: ApplicationStipulation[], 
  adverseActionReasons: IndirectDecisionReason[],
  decisionCodeDecisionReasonDefaults: DecisionCodeDecisionReasonDefault[]
): LoadApplicationStipsAndDecisionReasonsSuccessAction => {
  return {
    type: LOAD_INDIRECT_STIPS_AND_DECISION_REASONS_SUCCESS,
    payload: { applicationStipulations, adverseActionReasons, decisionCodeDecisionReasonDefaults }
  };
}

export const CREATE_DECISION_DENIAL_REASONS = 'CREATE_DECISION_DENIAL_REASONS';
export const CREATE_DECISION_DENIAL_REASONS_SUCCESS = 'CREATE_DECISION_DENIAL_REASONS_SUCCESS';
export const DELETE_DECISION_DENIAL_REASON = 'DELETE_DECISION_DENIAL_REASON';
export const DELETE_DECISION_DENIAL_REASON_SUCCESS = 'DELETE_DECISION_DENIAL_REASON_SUCCESS';

export interface CreateDecisionDenialReasonsAction {
  type: typeof CREATE_DECISION_DENIAL_REASONS;
  payload: { createDecisionDenialReasons: CreateIndirectDecisionDenialReasons };
}

export const createDecisionDenialReasons = (createDecisionDenialReasons: CreateIndirectDecisionDenialReasons): CreateDecisionDenialReasonsAction => {
  return {
    type: CREATE_DECISION_DENIAL_REASONS,
    payload: { createDecisionDenialReasons }
  };
}

export interface CreateDecisionDenialReasonsSuccessAction {
  type: typeof CREATE_DECISION_DENIAL_REASONS_SUCCESS;
  payload: { indirectDecisionReasons: IndirectDecisionReason[] };
}

export const createDecisionDenialReasonsSuccess = (indirectDecisionReasons: IndirectDecisionReason[]): CreateDecisionDenialReasonsSuccessAction => {
  return {
    type: CREATE_DECISION_DENIAL_REASONS_SUCCESS,
    payload: { indirectDecisionReasons }
  };
}

export interface DeleteDecisionDenialReasonAction {
  type: typeof DELETE_DECISION_DENIAL_REASON;
  payload: { indirectDecisionDenialReasonId: string };
}

export const deleteDecisionDenialReason = (indirectDecisionDenialReasonId: string): DeleteDecisionDenialReasonAction => {
  return {
    type: DELETE_DECISION_DENIAL_REASON,
    payload: { indirectDecisionDenialReasonId }
  };
}

export interface DeleteDecisionDenialReasonSuccessAction {
  type: typeof DELETE_DECISION_DENIAL_REASON_SUCCESS;
  payload: { indirectDecisionDenialReasonId: string };
}

export const deleteDecisionDenialReasonSuccess = (indirectDecisionDenialReasonId: string): DeleteDecisionDenialReasonSuccessAction => {
  return {
    type: DELETE_DECISION_DENIAL_REASON_SUCCESS,
    payload: { indirectDecisionDenialReasonId }
  };
}

export const ASSOCIATE_DOCUMENT_WITH_STIPULATIONS = 'ASSOCIATE_DOCUMENT_WITH_STIPULATIONS';
export const ASSOCIATE_DOCUMENT_WITH_STIPULATIONS_SUCCESS = 'ASSOCIATE_DOCUMENT_WITH_STIPULATIONS_SUCCESS';

export interface AssociateDocumentWithStipulationsAction {
  type: typeof ASSOCIATE_DOCUMENT_WITH_STIPULATIONS;
  payload: { associationInfo: CreateAppCustomerStipDocumentAssociation, stipulationCategories: IStipulationCategory[] };
}

export const associateDocumentWithStipulations = (associationInfo: CreateAppCustomerStipDocumentAssociation, stipulationCategories: IStipulationCategory[]): AssociateDocumentWithStipulationsAction => {
  return {
    type: ASSOCIATE_DOCUMENT_WITH_STIPULATIONS,
    payload: { associationInfo, stipulationCategories }
  };
}

export interface AssociateDocumentWithStipulationsSuccessAction {
  type: typeof ASSOCIATE_DOCUMENT_WITH_STIPULATIONS_SUCCESS;
  payload: { associationInfo: CreateAppCustomerStipDocumentAssociation, stipulationCategories: IStipulationCategory[] };
}

export const associateDocumentWithStipulationsSuccess = (associationInfo: CreateAppCustomerStipDocumentAssociation, stipulationCategories: IStipulationCategory[]): AssociateDocumentWithStipulationsSuccessAction => {
  return {
    type: ASSOCIATE_DOCUMENT_WITH_STIPULATIONS_SUCCESS,
    payload: { associationInfo, stipulationCategories }
  };
}

export const UPDATE_INDIRECT_STIPULATION = 'UPDATE_INDIRECT_STIPULATION';
export const UPDATE_INDIRECT_STIPULATION_SUCCESS = 'UPDATE_INDIRECT_STIPULATION_SUCCESS';

export interface UpdateIndirectStipulationAction {
  type: typeof UPDATE_INDIRECT_STIPULATION;
  payload: { applicationStipulationId: string, statusId: string, note: string };
}

export const updateIndirectStipulation = (applicationStipulationId: string, statusId: string, note: string): UpdateIndirectStipulationAction => {
  return {
    type: UPDATE_INDIRECT_STIPULATION,
    payload: { applicationStipulationId, statusId, note: note }
  };
}

export interface UpdateIndirectStipulationSuccessAction {
  type: typeof UPDATE_INDIRECT_STIPULATION_SUCCESS;
  payload: { applicationStipulationId: string, statusId: string, note: string };
}

export const updateIndirectStipulationSuccess = (applicationStipulationId: string, statusId: string, note: string): UpdateIndirectStipulationSuccessAction => {
  return {
    type: UPDATE_INDIRECT_STIPULATION_SUCCESS,
    payload: { applicationStipulationId, statusId, note }
  };
}

export const DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION = 'DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION';
export const DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION_SUCCESS = 'DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION_SUCCESS';

export interface DeleteAppCustomerStipDocumentAssociationAction {
  type: typeof DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION;
  payload: { applicationStipulationId: string, applicationStipulationDocumentId: string };
}

export const deleteAppCustomerStipDocumentAssociation = (applicationStipulationId: string, applicationStipulationDocumentId: string): DeleteAppCustomerStipDocumentAssociationAction => {
  return {
    type: DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION,
    payload: { applicationStipulationId, applicationStipulationDocumentId }
  };
}

export interface DeleteAppCustomerStipDocumentAssociationSuccessAction {
  type: typeof DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION_SUCCESS;
  payload: { applicationStipulationId: string, applicationStipulationDocumentId: string };
}

export const deleteAppCustomerStipDocumentAssociationSuccess = (applicationStipulationId: string, applicationStipulationDocumentId: string): DeleteAppCustomerStipDocumentAssociationSuccessAction => {
  return {
    type: DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION_SUCCESS,
    payload: { applicationStipulationId, applicationStipulationDocumentId }
  };
}

export type DealerServiceAction =
  SetDealerServiceCommentAction
  | SetDealerServiceDecisionCodeAction
  | SetDealerServiceStateAction
  | ClearDealerServiceStateAction
  | LoadIndirectStipsAndDecisionReasonsAction
  | LoadApplicationStipsAndDecisionReasonsSuccessAction
  | CreateDecisionDenialReasonsAction
  | CreateDecisionDenialReasonsSuccessAction
  | DeleteDecisionDenialReasonAction
  | DeleteDecisionDenialReasonSuccessAction
  | AssociateDocumentWithStipulationsAction
  | AssociateDocumentWithStipulationsSuccessAction
  | UpdateIndirectStipulationAction
  | UpdateIndirectStipulationSuccessAction
  | DeleteAppCustomerStipDocumentAssociationAction
  | DeleteAppCustomerStipDocumentAssociationSuccessAction;
